import { useState } from "react";

const SETUP_PASSWORD = "At151015&";

const SQL = `-- Depo Satışları tablosu
CREATE TABLE IF NOT EXISTS warehouse_sales (
  id              UUID PRIMARY KEY DEFAULT gen_random_uuid(),
  dealer_id       UUID NOT NULL,
  customer_name   TEXT,
  note            TEXT,
  payment_method  TEXT NOT NULL CHECK (payment_method IN ('nakit', 'kart', 'iban')),
  total_amount    NUMERIC(12,2) NOT NULL DEFAULT 0,
  staff_id        UUID,
  sale_type       TEXT DEFAULT 'warehouse',
  created_at      TIMESTAMPTZ DEFAULT NOW()
);

-- Depo Satış Kalemleri tablosu
CREATE TABLE IF NOT EXISTS warehouse_sale_items (
  id              UUID PRIMARY KEY DEFAULT gen_random_uuid(),
  sale_id         UUID NOT NULL REFERENCES warehouse_sales(id) ON DELETE CASCADE,
  product_id      UUID,
  quantity        NUMERIC(10,3) NOT NULL DEFAULT 1,
  unit_price      NUMERIC(12,2) NOT NULL DEFAULT 0,
  purchase_price  NUMERIC(12,2) DEFAULT 0,
  description     TEXT,
  created_at      TIMESTAMPTZ DEFAULT NOW()
);

-- İndeksler
CREATE INDEX IF NOT EXISTS idx_warehouse_sales_dealer_id    ON warehouse_sales(dealer_id);
CREATE INDEX IF NOT EXISTS idx_warehouse_sales_created_at   ON warehouse_sales(created_at);
CREATE INDEX IF NOT EXISTS idx_warehouse_sale_items_sale_id ON warehouse_sale_items(sale_id);

-- RLS
ALTER TABLE warehouse_sales      ENABLE ROW LEVEL SECURITY;
ALTER TABLE warehouse_sale_items ENABLE ROW LEVEL SECURITY;

CREATE POLICY IF NOT EXISTS "warehouse_sales_all" ON warehouse_sales
  FOR ALL USING (true) WITH CHECK (true);

CREATE POLICY IF NOT EXISTS "warehouse_items_all" ON warehouse_sale_items
  FOR ALL USING (true) WITH CHECK (true);`;

const SUPABASE_SQL_EDITOR = "https://supabase.com/dashboard/project/dimwpgeuqvtzlrlvveme/sql/new";

export default function WarehouseSetupPage() {
  const [copied, setCopied] = useState(false);
  const [step, setStep]     = useState(1);

  const [unlocked, setUnlocked]       = useState(false);
  const [pwInput, setPwInput]         = useState("");
  const [pwError, setPwError]         = useState("");

  const tryUnlock = () => {
    if (pwInput === SETUP_PASSWORD) {
      setUnlocked(true);
      setPwError("");
    } else {
      setPwError("Geçersiz şifre! Lütfen tekrar deneyin.");
    }
  };

  // ── Password gate ──────────────────────────────────────────────────────────
  if (!unlocked) {
    return (
      <div className="max-w-sm mx-auto py-16">
        <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8 text-center">
          <div className="w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-lock-line text-2xl text-amber-600"></i>
          </div>
          <h4 className="text-lg font-semibold text-foreground-950 mb-1">Depo Kurulumu</h4>
          <p className="text-sm text-foreground-500 mb-6">Bu sayfaya erişmek için şifre gereklidir.</p>

          <div className="mb-3">
            <input
              type="password"
              value={pwInput}
              onChange={(e) => { setPwInput(e.target.value); setPwError(""); }}
              onKeyDown={(e) => { if (e.key === "Enter") tryUnlock(); }}
              autoFocus
              placeholder="Şifrenizi girin"
              className="w-full px-3 py-2.5 bg-background-100 border border-background-200/70 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary-400"
            />
            {pwError && (
              <p className="text-xs text-accent-600 mt-1.5 flex items-center gap-1">
                <i className="ri-error-warning-line"></i> {pwError}
              </p>
            )}
          </div>

          <button
            onClick={tryUnlock}
            className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-semibold cursor-pointer transition-colors"
          >
            <i className="ri-unlock-line mr-1"></i> Giriş Yap
          </button>
        </div>
      </div>
    );
  }

  // ── Main setup UI ──────────────────────────────────────────────────────────

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(SQL);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    } catch {
      // fallback
      const ta = document.createElement("textarea");
      ta.value = SQL;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 3000);
    }
  };

  const openAndGo = async () => {
    await copy();
    setStep(2);
    window.open(SUPABASE_SQL_EDITOR, "_blank");
  };

  return (
    <div className="max-w-2xl mx-auto py-6">
      <div className="mb-6">
        <h4 className="text-lg font-semibold text-foreground-950">Depo Modülü Kurulumu</h4>
        <p className="text-sm text-foreground-500 mt-0.5">
          Depo modülünün çalışması için Supabase'e iki tablo eklenmesi gerekiyor.
          Aşağıdaki adımları takip edin — sadece 1 dakika sürer.
        </p>
      </div>

      {/* Steps */}
      <div className="space-y-4 mb-6">
        {/* Step 1 */}
        <div className={`border rounded-xl p-5 transition-all ${step >= 1 ? "border-primary-300 bg-primary-50/30" : "border-background-200/70"}`}>
          <div className="flex items-start gap-3">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shrink-0 ${step > 1 ? "bg-emerald-500 text-white" : "bg-primary-500 text-white"}`}>
              {step > 1 ? <i className="ri-check-line"></i> : "1"}
            </div>
            <div className="flex-1">
              <p className="font-semibold text-foreground-950 mb-1">SQL'i Kopyala ve Supabase'i Aç</p>
              <p className="text-sm text-foreground-500 mb-3">
                Butona tıklayın — SQL otomatik kopyalanır ve Supabase SQL Editor yeni sekmede açılır.
              </p>
              <button
                onClick={openAndGo}
                className="flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-lg text-sm font-semibold cursor-pointer transition-colors"
              >
                {copied
                  ? <><i className="ri-check-line"></i> Kopyalandı! Supabase açılıyor...</>
                  : <><i className="ri-clipboard-line"></i> SQL'i Kopyala &amp; Supabase'i Aç</>
                }
              </button>
            </div>
          </div>
        </div>

        {/* Step 2 */}
        <div className={`border rounded-xl p-5 transition-all ${step >= 2 ? "border-primary-300 bg-primary-50/30" : "border-background-200/70 opacity-50"}`}>
          <div className="flex items-start gap-3">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shrink-0 ${step > 2 ? "bg-emerald-500 text-white" : step === 2 ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-400"}`}>
              {step > 2 ? <i className="ri-check-line"></i> : "2"}
            </div>
            <div className="flex-1">
              <p className="font-semibold text-foreground-950 mb-1">Supabase'e Giriş Yapın</p>
              <p className="text-sm text-foreground-500 mb-3">
                Yeni sekmede Supabase açıldı. Eğer giriş yapılı değilse Google, GitHub veya e-posta ile giriş yapın.
              </p>
              {step === 2 && (
                <button onClick={() => setStep(3)} className="px-4 py-2 bg-secondary-100 text-secondary-700 rounded-lg text-sm font-medium cursor-pointer hover:bg-secondary-200/70">
                  Giriş yaptım, devam et →
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Step 3 */}
        <div className={`border rounded-xl p-5 transition-all ${step >= 3 ? "border-primary-300 bg-primary-50/30" : "border-background-200/70 opacity-50"}`}>
          <div className="flex items-start gap-3">
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold shrink-0 ${step > 3 ? "bg-emerald-500 text-white" : step === 3 ? "bg-primary-500 text-white" : "bg-background-200 text-foreground-400"}`}>
              {step > 3 ? <i className="ri-check-line"></i> : "3"}
            </div>
            <div className="flex-1">
              <p className="font-semibold text-foreground-950 mb-1">SQL Editor'a Yapıştırın ve Çalıştırın</p>
              <div className="text-sm text-foreground-500 space-y-1.5 mb-3">
                <p>1. Açılan sayfada beyaz metin alanına <strong>Ctrl+V</strong> (Mac: Cmd+V) ile yapıştırın</p>
                <p>2. Sağ alttaki yeşil <strong>"Run"</strong> butonuna tıklayın</p>
                <p>3. "Success" mesajını görünce tamamdır ✓</p>
              </div>
              {step === 3 && (
                <div className="flex gap-2">
                  <button
                    onClick={copy}
                    className="px-4 py-2 bg-background-100 border border-background-200/70 text-foreground-600 rounded-lg text-sm cursor-pointer hover:bg-background-200/70"
                  >
                    {copied ? "✓ Kopyalandı" : "SQL'i Tekrar Kopyala"}
                  </button>
                  <button
                    onClick={() => setStep(4)}
                    className="px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg text-sm font-semibold cursor-pointer"
                  >
                    Run'a bastım, tamamlandı ✓
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Done */}
      {step >= 4 && (
        <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-6 text-center">
          <i className="ri-checkbox-circle-fill text-4xl text-emerald-500 block mb-3"></i>
          <h5 className="font-bold text-emerald-800 text-lg mb-1">Kurulum Tamamlandı! 🎉</h5>
          <p className="text-sm text-emerald-700 mb-4">
            Depo modülü artık kullanıma hazır. Sol menüden "Depo POS", "Depo Stok" ve raporlara erişebilirsiniz.
          </p>
          <a href="/warehouse/pos" className="inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-500 hover:bg-emerald-600 text-white rounded-lg text-sm font-semibold cursor-pointer transition-colors">
            <i className="ri-store-3-line"></i> Depo POS'a Git
          </a>
        </div>
      )}

      {/* SQL Preview (collapsible) */}
      <details className="mt-6">
        <summary className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-600 flex items-center gap-1">
          <i className="ri-code-line"></i> SQL içeriğini görüntüle
        </summary>
        <pre className="mt-2 p-4 bg-background-100 border border-background-200/70 rounded-xl text-xs text-foreground-600 overflow-x-auto whitespace-pre-wrap">
          {SQL}
        </pre>
      </details>
    </div>
  );
}
